import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { GraphemeMorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";

/** Whether the "as component" box has anything to show (so the collapse budget can skip it). */
export function useHasMorphemeMnemonicsMeaningAsComponent() {
  const [hasAsComponent] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (context) =>
      (context.readonlySlice.data.description?.trim() ?? "") !== "" ||
      context.readonlySlice.data.mnemonicTerms.length > 0,
  );
  return hasAsComponent;
}
